import React from 'react'
import PropTypes from 'prop-types'

import { FormWrapper, Selection } from 'components';

import { Form, Modal, Header, TransitionablePortal } from 'semantic-ui-react'

import { API } from 'services';

class ModalLinkDevice extends React.Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      devices: [],
      fetching: false,
      actions: {
        submit: {
          name: "Valider",
          callback: this.handleSubmit,
          active: false
        },
        cancel: {
          name: "Annuler",
          callback: this.props.onClose
        }
      }
    };
  }

  componentDidMount() {

    //Request fetch
    this.setState({
      devices: [],
      fetching: true
    });
  }

  componentDidUpdate(prevProps, prevState) {

    if(!prevState.fetching && this.state.fetching) {

      //Load available devices
      API.get('/devices', { filter: 'available' })
        .then((response) => {

          this.setState({
            devices: response.data
          });
        })
        .finally(() => {
          this.setState({
            fetching: false
          });
        });

    }
  }

  handleChange(event) {
    this.setState({
      actions: {
        ...this.state.actions,
        submit: {
          ...this.state.actions.submit,
          active: true
        }
      }
    });
  }

  handleSubmit(data, onSucess, onError) {

    API.put(`/clinics/${this.props.clinic.id}/devices/${data.device}`)
      .then((response) => {
        this.props.onClose(response.data);
      })
      .catch((error) => {
        onError({'device': [error.response.data.message]});
     });
  }

  render() {

    let availableDevices = this.state.devices.map((device) => {
      return {
        key: device.id,
        text: device.id,
        value: device.id
      };
    });

    return (
      <TransitionablePortal open transition={{ animation: "fade down", duration: 250 }}>
        <Modal open size="small">
          <Header icon="add" content="Associer une valise" />
          <Modal.Content>

            <FormWrapper actions={this.state.actions}>

              {/* Name */}
              <Form.Field>
                <label htmlFor="inputProduct">Numéro de produit</label>
                <Selection
                  placeholder={this.state.fetching ? 'Chargement' : null}
                  loading={this.state.fetching}
                  id="inputProduct"
                  name="device"
                  options={availableDevices}
                  noResultsMessage="Aucune valise n'est disponible"
                  onChange={this.handleChange}
                />
              </Form.Field>

            </FormWrapper>

          </Modal.Content>
        </Modal>
      </TransitionablePortal>
    );
  }
}

ModalLinkDevice.propTypes = {
  onClose: PropTypes.func.isRequired,
  device: PropTypes.shape({
    id: PropTypes.number.isRequired
  })
};

export default ModalLinkDevice;
